/**
 * Transform Content API padding to SpaceProps / MarginProps format
 */
import type {MarginProps, SpaceProps} from "@/sections/use-section-space";

import type {ContentApiResponsivePadding} from "./section-types";

/**
 * Convert Content API responsive padding to SpaceProps
 * @param padding - Content API responsive padding structure
 * @returns SpaceProps with pt, pb, ptm, pbm values as strings with "px" suffix
 */
export function transformPadding(padding?: ContentApiResponsivePadding): SpaceProps | undefined {
    if (!padding) {
        return undefined;
    }

    const space: SpaceProps = {};

    // Desktop padding
    if (padding.desktop.top !== undefined) {
        space.pt = `${padding.desktop.top}px`;
    }
    if (padding.desktop.bottom !== undefined) {
        space.pb = `${padding.desktop.bottom}px`;
    }

    // Mobile padding
    if (padding.mobile.top !== undefined) {
        space.ptm = `${padding.mobile.top}px`;
    }
    if (padding.mobile.bottom !== undefined) {
        space.pbm = `${padding.mobile.bottom}px`;
    }

    // Return undefined if no padding values were set
    return Object.keys(space).length > 0 ? space : undefined;
}

/**
 * Convert Content API responsive padding to MarginProps
 * @param padding - Content API responsive padding structure
 * @returns MarginProps with mt, mb, mtm, mbm values as strings with "px" suffix
 */
export function transformPaddingToMargin(padding?: ContentApiResponsivePadding): MarginProps | undefined {
    if (!padding) {
        return undefined;
    }

    const margin: MarginProps = {};

    // Desktop margin
    if (padding.desktop.top !== undefined) {
        margin.mt = `${padding.desktop.top}px`;
    }
    if (padding.desktop.bottom !== undefined) {
        margin.mb = `${padding.desktop.bottom}px`;
    }

    // Mobile margin
    if (padding.mobile.top !== undefined) {
        margin.mtm = `${padding.mobile.top}px`;
    }
    if (padding.mobile.bottom !== undefined) {
        margin.mbm = `${padding.mobile.bottom}px`;
    }

    // Return undefined if no margin values were set
    return Object.keys(margin).length > 0 ? margin : undefined;
}
